// extracted by mini-css-extract-plugin
export default {"dashboardWrapper":"dashboard_dashboardWrapper__W4Ndl"};